import { render, staticRenderFns } from "./ModalCreateNewContext.vue?vue&type=template&id=4bc83542&scoped=true"
import script from "./ModalCreateNewContext.vue?vue&type=script&lang=js"
export * from "./ModalCreateNewContext.vue?vue&type=script&lang=js"
import style0 from "./ModalCreateNewContext.vue?vue&type=style&index=0&id=4bc83542&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc83542",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bc83542')) {
      api.createRecord('4bc83542', component.options)
    } else {
      api.reload('4bc83542', component.options)
    }
    module.hot.accept("./ModalCreateNewContext.vue?vue&type=template&id=4bc83542&scoped=true", function () {
      api.rerender('4bc83542', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/ModalCreateNewContext.vue"
export default component.exports